import { Row } from 'components-antd';
import styles from './styles.module.scss';
import classNames from 'classnames';
import React from 'react';

type ModalSectionsType = {
  children: React.ReactNode;
  className?: string;
};

export const ModalSections = ({ children, className }: ModalSectionsType) => {
  return (
    <Row gutter={24} className={classNames(styles.modalSectionsRow, className)}>
      {children}
    </Row>
  );
};
